module.exports = __webpack_public_path__ + "assets/img/11_725_1.834ee54a.jpg";